import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Mail, MessageSquare } from 'lucide-react';
import ContactModal from './ContactModal';
import ElyaChat from './ElyaChat';

export default function FloatingButtons() {
  const [showContactModal, setShowContactModal] = useState(false);
  const [showElyaChat, setShowElyaChat] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // Détecter si le menu mobile est ouvert en observant le body overflow
  useEffect(() => {
    const observer = new MutationObserver(() => {
      setIsMobileMenuOpen(document.body.style.overflow === 'hidden');
    });
    
    observer.observe(document.body, { 
      attributes: true, 
      attributeFilter: ['style'] 
    });
    
    return () => observer.disconnect();
  }, []);

  return (
    <>
      {/* Contact Button (Bottom Left) - Caché quand menu mobile ouvert */}
      <AnimatePresence>
        {!isMobileMenuOpen && (
          <motion.button
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.5 }}
            transition={{ duration: 0.3 }}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => setShowContactModal(true)}
            style={{
              position: 'fixed',
              bottom: '2rem',
              left: '2rem',
              zIndex: 10010
            }}
            className="w-14 h-14 rounded-full bg-gradient-to-br from-[#3B1E73] to-[#1B0F3B] border border-[#FFD86F]/20 flex items-center justify-center cursor-pointer transition-all hover:shadow-[0_0_20px_rgba(255,216,111,0.6)] md:w-16 md:h-16"
            aria-label="Ouvrir le formulaire de contact"
          >
            <Mail className="w-6 h-6 text-white md:w-7 md:h-7" />
          </motion.button>
        )}
      </AnimatePresence>

      {/* Elya AI Assistant Button (Bottom Right) - Caché quand menu mobile ouvert */}
      <AnimatePresence>
        {!isMobileMenuOpen && (
          <motion.button
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.5 }}
            transition={{ duration: 0.3 }}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => setShowElyaChat(true)}
            style={{
              position: 'fixed',
              bottom: '2rem',
              right: '2rem',
              zIndex: 10010
            }}
            className="w-14 h-14 rounded-full bg-gradient-to-br from-[#FFD86F] to-[#FFC933] border border-[#3B1E73]/30 flex items-center justify-center cursor-pointer transition-all hover:shadow-[0_0_30px_rgba(255,216,111,0.8)] relative overflow-visible md:w-16 md:h-16"
            aria-label="Discuter avec Elya, l'assistante IA"
          >
            {/* Glow pulse effect - Behind the icon */}
            <span className="absolute inset-0 rounded-full bg-[#FFD86F]/30 animate-ping opacity-75 -z-10"></span>
            {/* Icon - Above the pulse */}
            <MessageSquare className="w-6 h-6 text-[#1B0F3B] relative z-10 md:w-7 md:h-7" />
          </motion.button>
        )}
      </AnimatePresence>

      {/* Contact Modal */}
      <AnimatePresence>
        {showContactModal && (
          <ContactModal onClose={() => setShowContactModal(false)} />
        )}
      </AnimatePresence>

      {/* Elya Chat */}
      <AnimatePresence>
        {showElyaChat && (
          <ElyaChat onClose={() => setShowElyaChat(false)} />
        )}
      </AnimatePresence>
    </>
  );
}
